export default __webpack_public_path__ + "static/desk04-5fa8b0c56a86a92faf13f1f0fc939415.png";